export default function get_query_params() {
  const queryString = window.location.search;
  return new URLSearchParams(queryString);
}
